import { getConfig } from '@superbet-group/web.lib.config';
import { Locale } from '@superbet-group/web.types';

let activeLanguageStringComparator: LocaleSensitiveStringComparator | null = null;

export function getActiveLanguageStringComparator(): LocaleSensitiveStringComparator {
    if (!activeLanguageStringComparator) {
        activeLanguageStringComparator = getLocaleStringComparator(getConfig().appLocale.locale);
    }

    return activeLanguageStringComparator;
}

export function clearActiveLanguageStringComparator(): void {
    activeLanguageStringComparator = null;
}

// Exported for testing
export function getLocaleStringComparator(locale: Locale): LocaleSensitiveStringComparator {
    const collator = new Intl.Collator(locale, { numeric: true });

    return (a, b) => {
        if (a === undefined && b === undefined) {
            return 0;
        } else if (a === undefined && b !== undefined) {
            return -1;
        } else if (a !== undefined && b === undefined) {
            return 1;
        } else {
            return collator.compare(a!, b!);
        }
    };
}

type LocaleSensitiveStringComparator = (a?: string, b?: string) => number;
